import { render } from "./single.vue?vue&type=template&id=70594343&scoped=true&ts=true&lang=pug"
import script from "./single.vue?vue&type=script&lang=ts"
export * from "./single.vue?vue&type=script&lang=ts"

import "./single.vue?vue&type=style&index=0&id=70594343&lang=stylus&scoped=true"

import exportComponent from "/builds/findsoft/hero/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70594343"]])

export default __exports__